// @flow
import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {trigger as edapTrigger} from '../../utils/edapWrapper';
import {canonicalizeSearchRequest} from '../../utils/searchParamsUtils';
import {toURL} from '@homeaway/search-url-parser';
import {ButtonPrimary} from '@homeaway/react-buttons';

import type {State as ReduxState} from '../../reducers';
import type {TripQuery} from '../../utils/tripData';

import './FallbackComponent.less';

type UrlProps = {
    q?: string
} & TripQuery;

type Props = {
    siteName: string
} & UrlProps;

// TODO: replace with the 404 page from SERP-343
export class FallbackComponent extends Component<Props> {
    componentDidMount() {
        this.didHaveError();
    }

    buildRedirectUrl = () => {
        const {
            siteName,
            adultsCount,
            arrival,
            childrenCount,
            departure,
            petIncluded,
            q
        } = this.props;

        const searchRequest = canonicalizeSearchRequest({
            adultsCount,
            arrival,
            childrenCount,
            departure,
            petIncluded,
            q
        });
        return toURL(searchRequest, {siteName});
    };

    didHaveError = () => {
        edapTrigger('generic.error', {
            logmessage: 'oops',
            highfrequency: 'true'
        });
    };

    render() {
        const href = this.buildRedirectUrl();
        return (
            <div className="FallbackComponent" data-wdio="FallbackComponent">
                <FormattedMessage tagName="h3" id="tempOopsMessage" />
                <div data-wdio="FallbackComponent_link">
                    <ButtonPrimary
                        id={'tempsOopsRedirect'}
                        href={href}
                        label={<FormattedMessage id="tempOopsRedirect" />}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({
    system: {siteName},
    searchParams: {
        params: {adultsCount, arrival, childrenCount, departure, petIncluded, q}
    }
}: ReduxState): Props => ({
    siteName,
    adultsCount,
    arrival,
    childrenCount,
    departure,
    petIncluded,
    q
});

export default compose(connect(mapStateToProps))(FallbackComponent);
